@code {
  /** Referenced by the `toggles` of the `Button` that opens it, which it is anchored to. */
  id = "";
}

<div class="xz-popover" data-kind="menu" id="@id" popover data-depth="2">@slot</div>
